import React from 'react';
import { Carousel, Card, Avatar, Rate } from 'antd';
import './custom-carousel.css'; // We'll create this file for custom styling

// Simulated JSON data
const reviews = [
  {
    author_name: 'Arvis Šneiders',
    profile_photo_url: 'https://lh3.googleusercontent.com/a/ACg8ocL7sbmqMmc4qE2c-CsOo-erw5fbr7ba0j2ljxMMcY6Jy5S9q8Q=w60-h60-p-rp-mo-br100',
    rating: 5,
    text: 'Ātri un kvalitatīvi, iesaku',
    relative_time_description: 'Pirms 4 nedēļām',
  },
  {
    author_name: 'Hubris',
    profile_photo_url: 'https://lh3.googleusercontent.com/a-/ALV-UjWv_M-emqeghP3gYLnuW2ySdXTRR2M5KHwvfpe6Dt_ceEfvDqZw=w60-h60-p-rp-mo-br100',
    rating: 5,
    text: 'Супер качество!👍👌',
    relative_time_description: 'Pirms 4 mēnešiem',
  },
  {
    author_name: 'markuss fridenbergs Lv',
    profile_photo_url: 'https://lh3.googleusercontent.com/a-/ALV-UjUsO0eSQhc19JVrXzCLizqU6z06VQmzjq0NRnE2e28Y5OuZKIM=w60-h60-p-rp-mo-br100',
    rating: 5,
    text: 'Atri un kvalitatīvi',
    relative_time_description: 'Pirms 5 mēnešiem',
  },
  {
    author_name: 'Loreta Linincuka',
    profile_photo_url: 'https://lh3.googleusercontent.com/a/ACg8ocJJt8JgxWoiNPS-aIGvyTWe0rmJzArm8A_A5-OvO0IqmV0_21Y=w60-h60-p-rp-mo-br100',
    rating: 5,
    text: 'Super paldies! :D',
    relative_time_description: 'Pirms 4 mēnešiem',
  },
  {
    author_name: 'Māris "Lords" Urbans',
    profile_photo_url: 'https://lh3.googleusercontent.com/a-/ALV-UjWNxJg4aNoJcC3RhBbwntH6vb4fhcfT5NeKO1NFz6oyZbng2Kg=w60-h60-p-rp-mo-br100',
    rating: 5,
    text: 'Ir OK',
    relative_time_description: 'Pirms 3 nedēļām',
  },
  {
    author_name: 'Gundars Auzins',
    profile_photo_url: 'https://lh3.googleusercontent.com/a/ACg8ocK5F9drwGnCob_1iXPvAs2WllKn3Dkax6Rpvf8LlxQo2dBotQ=w60-h60-p-rp-mo-ba2-br100',
    rating: 5,
    text: 'Super meistars',
    relative_time_description: 'Pirms 2 nedēļām',
  },
  {
    author_name: 'Nils Strazdiņš',
    profile_photo_url: 'https://lh3.googleusercontent.com/a/ACg8ocKLAphf8Rx1bGR95z9FF1OndWR-PufnQ6_zkH8RIU-OuStRoA=s64-c-rp-mo-br100',
    rating: 5,
    text: '',
    relative_time_description: 'Pirms 2 dienām',
  },
  {
    author_name: 'sm ud',
    profile_photo_url: 'https://lh3.googleusercontent.com/a-/ALV-UjW0EFb0LaYvNKkEOD-_2uhJHcNiWpcZK4edqoxllskB35G7a1Q=s64-c-rp-mo-br100',
    rating: 5,
    text: '',
    relative_time_description: 'Pirms 3 mēnešiem',
  },
  {
    author_name: 'Nikita Kaunov [HP]',
    profile_photo_url: 'https://lh3.googleusercontent.com/a-/ALV-UjWKl8uK5rCBDiZ5lkTMhw6svYUeHify7Zcsn9lbY_oBWNGvJo4u=s64-c-rp-mo-br100',
    rating: 5,
    text: "Super labs tonēšanas serviss,atrī un profesionāli dara, jebkura veida un jūsu vēlmju tonēšana!!! Iesaku šo vietu!!!",
    relative_time_description: 'Pirms 1 nedēļas',
  },
  {
    author_name: 'ričards rozentāls',
    profile_photo_url: 'https://lh3.googleusercontent.com/a-/ALV-UjWrm8H84A9wKRu2tuPu0F-CvbLApeV8wrzU2mRgDvuP2uJkZ3g=s64-c-rp-mo-br100',
    rating: 5,
    text: "Ideali izdarija darbu, un ļoti precizi un ātri, kā arī izstastīja par plevēm un to īpašībām! Iesaku!",
    relative_time_description: 'Pirms 2 nedēļām',
  },
  {
    author_name: 'Marija Kamela',
    profile_photo_url: 'https://lh3.googleusercontent.com/a/ACg8ocJSXZlVjBeTrChqqdl7acgUKZ-Ln9vP6X28_0gbolfzfG6UaGiJ=s64-c-rp-mo-br100',
    rating: 5,
    text: "Ļoti profesionāls un kvalitatīvs darbs! Logu tonēšana tika veikta ātri un precīzi, un rezultāts ir lielisks – auto izskatās stilīgi, un salonā ir patīkamāka sajūta",
    relative_time_description: 'Pirms 2 nedēļām',
  },
  
];

const Reviews = () => {
  return (
    <div className='bg-gray-800 w-full py-8 md:py-12'>
      {/* Container with fixed margin on larger screens, responsive on mobile */}
      <div className='mx-4 md:mx-12 lg:mx-24 xl:mx-72 max-w-screen-2xl'>
        <h2 className='text-2xl md:text-3xl font-semibold text-white text-center mb-8'>
          ATSAUKSMES
        </h2>
        
        <div className="carousel-container pb-10"> {/* Added padding bottom for dots */}
          <Carousel
            autoplay
            dots={{ className: 'custom-dots' }}
            className='max-w-full mx-auto'
            slidesToShow={3}
            responsive={[
              {
                breakpoint: 1280,
                settings: {
                  slidesToShow: 2,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  arrows: false,
                  autoplaySpeed: 4000,
                },
              },
            ]}
          >
            {reviews.map((review, index) => (
              <div key={index} className='px-2 pb-4'>
                <Card 
                  hoverable
                  className="bg-gray-800 text-white"
                  styles={{
                    body: { padding: '16px' }
                  }}
                >
                  {/* Google "G" Logo */}
                  <img
                    src='https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/1024px-Google_%22G%22_logo.svg.png'
                    alt='Google Logo'
                    className='w-4 h-4 md:w-6 md:h-6 absolute top-4 right-4 md:top-6 md:right-6'
                  />
                  <Card.Meta
                    avatar={
                      <Avatar
                        src={review.profile_photo_url}
                        alt={review.author_name}
                        className='w-12 h-12 md:w-16 md:h-16'
                      />
                    }
                    title={
                      <div className='flex flex-col'>
                        <span className='text-base md:text-xl font-semibold text-gray-800 truncate'>
                          {review.author_name}
                        </span>
                        <Rate
                          disabled
                          defaultValue={review.rating}
                          className='text-yellow-500 text-sm md:text-base'
                        />
                      </div>
                    }
                    description={
                      <>
                        <p className='text-sm md:text-base text-gray-600 mt-2 line-clamp-3'>
                          {review.text}
                        </p>
                        <p className='text-xs md:text-sm text-gray-500 mt-2'>
                          {review.relative_time_description}
                        </p>
                      </>
                    }
                  />
                </Card>
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default Reviews;